import { firstLetterToUpperCase } from '@/main/services/utilsString';
import { useVisualIdentityReducer } from '@/main/store/visualIdentity';
import { Radio, TableCell, TableRow } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import BoxGrid from '../boxGrid/boxGrid';

interface IOptionElement {
  content: string | React.ReactNode;
  width?: string | number;
}

export type IOptionGridRadio = {
  id: string;
  elements: IOptionElement[];
  idForTests?: string;
};

interface IKOGBoxGridRadioProps {
  nameCustom: string;
  options: IOptionGridRadio[];
  optionsSelected: string | null;
  setOptionsSelected: Dispatch<SetStateAction<string | null>>;
  onClickCustom?: (option: IOptionGridRadio, event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
  disabled?: boolean;
}

function KogRadioGroupComponent({
  nameCustom,
  options,
  optionsSelected,
  disabled,
  setOptionsSelected,
  onClickCustom = () => { },
  ...props
}: IKOGBoxGridRadioProps) {
  const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOptionsSelected((event.target as HTMLInputElement).value);
  };

  return (
    <BoxGrid
      {...props}
    >
      {options.map(option => (
        <TableRow key={option.id} onClick={(e) => onClickCustom(option, e)}>
          <TableCell width="1%">
            <Radio
              style={!disabled ? { color: visualIdentityReducer.colors.pantone2726C } : { color: "#d7d7d7" }}
              checked={optionsSelected === option.id}
              onChange={handleRadioChange}
              value={option.id}
              name={nameCustom}
              disabled={disabled}
              id={option.idForTests}
            />
          </TableCell>
          {option.elements.map((item, index) => (
            <TableCell key={`${option.id}-${index}`} width={item.width}>
              {typeof item.content === 'string' ? firstLetterToUpperCase(item.content) : item.content}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </BoxGrid>
  );
}

export default KogRadioGroupComponent;